import { BooleanInput, Create, required, SimpleForm } from 'react-admin';
import EditToolbar from '../../Components/EditToolbar';
import ExternalCategoryAutocompleteInput from './ExternalCategoryAutocompleteInput';
import { ReactElement } from 'react';
import JsonApiHasOneReferenceInput from '../../Components/JsonApiHasOneReferenceInput';
import MappingRuleResource from '../../Entities/MappingRules';

export default function MappingRuleCreate(): ReactElement {
  return (
    <Create>
      <SimpleForm toolbar={<EditToolbar />}>
        <JsonApiHasOneReferenceInput<MappingRuleResource>
          filterFields={['merchant_name']}
          label="Merchant"
          nullable={false}
          optionText="attributes.merchant_name"
          reference="merchants"
          source="relationships.merchant"
          validate={required()}
        />
        <ExternalCategoryAutocompleteInput />
        <JsonApiHasOneReferenceInput<MappingRuleResource>
          label="Category"
          optionText="attributes.full_name"
          reference="categories"
          referenceInputProps={{ filter: { level: 0 } }}
          source="relationships.category"
        />
        <BooleanInput
          defaultValue={false}
          label="Ignore New Offers Matching Rule In Scan"
          source="attributes.ignored"
        />
        <BooleanInput
          defaultValue={false}
          label="Should be hidden by default in CMS"
          source="attributes.is_hidden"
        />
      </SimpleForm>
    </Create>
  );
}
